/*
 * Replace/augment global Promise before axios tries to use it.
 * This is to support IE11, which doesn't support JS Promises.
 */
import { polyfill } from "es6-promise";

import axios from "axios";
import URI from "urijs";

polyfill();

/*
 * Evaluate the application context (e.g. /QLMSourcing) from the current
 * application URL.
 * Split on the slash, take the first two components (first is empty), then
 * join them back together again.
 */
const BASE_PATH = window.location.pathname.split("/").slice(0, 2).join("/");

/*
 * Write this parameter/value into legacy Tapestry URLs.  When rendering the
 * resulting page, if the parameter/value is present in the URL, then we know
 * we've come from the JavaScript world, rather than Tapestry.  In this case,
 * we have to use the native back button behaviour, rather than the history
 * mechanism provided by Tapestry.
 */
const CLIENT_URL_INDICATOR = "js=true";

/*
 * Generate a legacy Tapestry URL with component name and service parameter
 * entries.
 */
const legacyUrl = (page, params = [], component = null) => {
  const requestParams = [
    "session=T",
    ...(component ? [`component=${component}`] : []),
    ...params.map(p => `sp=S${p}`),
    CLIENT_URL_INDICATOR
  ].join("&");
  return `${BASE_PATH}/secure/${page}.external?${requestParams}`;
};

const isClientUrl = url => {
  return url.includes(CLIENT_URL_INDICATOR);
};

/*
 * Make an API call using GET.
 */
const get = (service, method, ...params) =>
  axios.get(apiUrl(service, method, params));

/*
 * Make an API call using POST.
 */
const post = (service, method, ...data) => {
  // Use multipart form data
  const config = {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  };

  // Extract function to make reduce statement more clear, perhaps
  const stringify = (acc, e, index) => {
    acc.append(`field${index}`, JSON.stringify(e));
    return acc;
  };

  // Stringify each input argument and append to a FormData instance
  data = data ? data : [];
  const formData = data.reduce(stringify, new FormData());

  // Post the resulting FormData to the server
  return axios.post(apiUrl(service, method), formData, config);
};

/*
 * Generate a URL to call a service method with optional parameter.
 */
const apiUrl = (service, method, params) => {
  params = params ? params : [];
  const paramString = params.join("/");
  return URI(`${BASE_PATH}/api/${service}/${method}/${paramString}`);
};

/*
 * Generate a URL to call a QLMSourcing servlet (e.g. the upload servlet) given
 * the servlet path.
 */
const sourcingUrl = path => {
  return URI(`${BASE_PATH}/${path}`);
};

export { get, post };

export { isClientUrl, legacyUrl, sourcingUrl };
